import { Id } from "../types";
import { app } from "./app";
import { getAnalytics, logEvent, setUserId } from "firebase/analytics";

export const analytics = getAnalytics(app);

export function analyticsLogEvent(
  eventName: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventParams: Record<string, any> = {},
) {
  logEvent(analytics, eventName, eventParams);
}

export function analyticsSetUserId(userId: Id) {
  setUserId(analytics, userId);
}

export function analyticsReportError(err: Error) {
  logEvent(analytics, "error", {
    name: err.name || "<unknown>",
    message: err.message,
  });
  console.error(err);
}
